import axios from "axios"
import { Toast, Dialog } from "vant";
import router from "../router"

router.beforeEach((to, from, next) => {
	localStorage.setItem('Route', to.path)
	next()
});

const TIMEOUT = 10 * 1000
// const baseURL = 'http://localhost:9595/api/app/v1/'
const baseURL = "https://kpapi.kpjkgl.com/api-t/api/app/v1/"
const service = axios.create({
  timeout: TIMEOUT,
  baseURL: baseURL,
  withCredentials: true
});
// window全局监听localStorage的setItem事件以及时更新
// window.addEventListener('setItemEvent', function (e) {
//   reqHeaders[e.key] = e.newValue
//   console.info(reqHeaders)
// })

service.interceptors.request.use(
  config => {
      // do something before request is sent
      config.headers['Uid'] = localStorage.getItem('Uid'), // Uid标识
      config.headers['Route'] = localStorage.getItem('Route'), // 当前路由
      config.headers['CompanyId'] = localStorage.getItem('CompanyId') && localStorage.getItem('CompanyId') != 'mull' ? localStorage.getItem('CompanyId') : '',
      // TestingRecordId: localStorage.getItem('TestingRecordId') && localStorage.getItem('TestingRecordId') != '' ? localStorage.getItem('TestingRecordId') : '',
      config.headers['Token'] = localStorage.getItem('Token') // 鉴权
      return config
  },
  error => {
      // do something with request error
      console.log(error) // for debug
      return Promise.reject(error)
  }
)

function tokenLogin() {
  if (location.href.indexOf('token') >= 0) {
    // 放入机构ID
    if (location.href.indexOf('companyId') >= 0) {
      localStorage.setItem('CompanyId', getQueryVariable('companyId'))
    }
    // 带token，自动登录
    var token = getQueryVariable('token')
    // 尝试token login登录
    localStorage.setItem('TokenLogin', true)
    service({
      url: 'login/token',
      method: 'post',
      params: {
        token: token
      }
    }).then(res => {
      if (res && res.token) {
        localStorage.setItem('reload', true)
        localStorage.setItem('Token', res.token)
        localStorage.setItem('UserId', res.userId)
        localStorage.setItem('Tel', res.tel)
        window.location.reload()
      } else {
        showLogin()
      }
    })
  } else {
    showLogin()
  }
}

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      // 保存路径
      if (res.code === 402) {
        tokenLogin()
      } else {
        Toast(res.message)
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      if (location.href.indexOf('token') >= 0 
        && !(localStorage.getItem('TokenLogin') 
        && localStorage.getItem('TokenLogin') == 'true')) {
        tokenLogin()
      } else {
        return res.data
      }
    }
  },
  error => {
    Toast('系统有误')
    return Promise.reject(error)
  }
)

export default service

export function showLogin() {
  localStorage.setItem('CachePage', location.href)
  Dialog.confirm({
    title: '提示',
    message:
      '用户未登录，是否立即前往登录？',
  })
  .then(() => {
    service({
      url: 'page/event',
      method: 'post',
      data: {
        code: 'to-login',
        params: {}
      }
    })
    router.push({
      path: '/login',
      query: {
        companyId: localStorage.getItem('CompanyId')
      }
    })
  })
}

export function getQueryVariable(name) {
  var url = window.location.href
  if (url.indexOf('?') == 1) { return false; }
  url = url.split('?')[1]
  url = url.split('&')
  var name = name || ''
  var nameres
  // 获取全部参数及其值
  for(var i=0;i<url.length;i++) {
      var info = url[i].split('=')
      var obj = {}
      obj[info[0]] = decodeURI(info[1])
      url[i] = obj
  }
  // 如果传入一个参数名称，就匹配其值
  if (name) {
    for(var i=0;i<url.length;i++) {
      for (const key in url[i]) {
        if (key == name) {
          nameres = url[i][key]
        }
      }
    }
  } else {
    nameres = url
  }
  // 返回结果
  return nameres
}

export function dealCachePage() {
  if (localStorage.getItem('CachePage')) {
    var path = localStorage.getItem('CachePage')
    localStorage.setItem('CachePage', '')
    location.href = path
  }
}